import {
  GroupedInvestmentModel,
  ManagerModel,
} from "@verivest/shared-components/src/api/models";

export interface WLManagerNotPendingInvestmentsProps {
  manager?: ManagerModel;
  investments?: GroupedInvestmentModel[];
  updateFilter: (filter: SortOptionType) => void;
  filter: SortOptionType;
}

export enum SortDirectionsEnum {
  active = "active",
  realized = "realized",
}

export interface SortOptionType {
  sortBy: string;
  sortDirection: SortDirectionsEnum;
  label: string;
}
